import React, { useState } from "react";
import { Grommet, Box, ResponsiveContext } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { Header, Notification, AgentSidebar, PageFooter } from './components';
import { Home } from './pages/home';
import { HomeTest } from './pages/home';
import { BlogHome } from './pages/blog';
import { ConfrmsHome } from './pages/occupancy/confrms';
import { HeadcountHome } from './pages/occupancy/headcount';
import { WkstsHome } from './pages/occupancy/wksts';
import { AirHome } from './pages/wellbeing/air';
import { SecurityHome } from './pages/wellbeing/security';
import { TemperatureHome } from './pages/wellbeing/temperature';
import { NetworkHome } from './pages/reliability/network';
import { WaterHome } from './pages/reliability/water';
import { GasHome } from './pages/reliability/gas';
import { ElectricityHome } from './pages/reliability/electricity';
import { SustainabilityHome } from './pages/sustainability';
import { LearnHome } from './pages/learn';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HeaderHeightProvider } from './utils/HeaderHeightContext';


function App() {

    // State to track if the agent dialog is expanded or collapsed
  const [isAgentExpanded, setIsAgentExpanded] = useState(false);

  // Toggle function to expand/collapse the agent
  const toggleAgent = () => {
    setIsAgentExpanded((prev) => !prev);
  };
  
  return (
    <HeaderHeightProvider> 
      <BrowserRouter>
        <Grommet className="App" theme={hpe} full>
          <ResponsiveContext.Consumer>
            {size => (
              <Box fill background="background-back" direction="column" style={{ height: '100vh' }}>

                {/* Header */}
                <Box width="100%" elevation="medium" flex={false}>
                  <Header toggleAgent={toggleAgent} />
                </Box>

                {/* Main Content */}
                <Box flex="grow" overflow="auto">
                  <Notification />
                  <Box margin={{ top: 'xxsmall' }} direction="row" flex="grow" >
                    <Box flex={true} overflow="auto">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/hometest" element={<HomeTest />} />
                        <Route path="/occupancy/conferencerooms" element={<ConfrmsHome />} />
                        <Route path="/occupancy/headcount" element={<HeadcountHome />} />
                        <Route path="/occupancy/workstations" element={<WkstsHome />} />
                        <Route path="/wellbeing/air" element={<AirHome />} />
                        <Route path="/wellbeing/security" element={<SecurityHome />} />
                        <Route path="/wellbeing/temperature" element={<TemperatureHome />} />
                        <Route path="/reliability/network" element={<NetworkHome />} />
                        <Route path="/reliability/water" element={<WaterHome />} />
                        <Route path="/reliability/gas" element={<GasHome />} />
                        <Route path="/reliability/electricity" element={<ElectricityHome />} />                        
                        <Route path="/sustainability" element={<SustainabilityHome />} />                        
                        <Route path="/learn" element={<LearnHome />} />
                        <Route path="/blog" element={<BlogHome />} />
                        <Route path="*" element={<Home />} />
                      </Routes>  
                    </Box>
                    <AgentSidebar isAgentExpanded={isAgentExpanded} />
                  </Box>
                </Box>

                {/* Footer */}
                <Box width="100%" flex={false}>
                  <PageFooter />
                </Box>

              </Box>
            )}
          </ResponsiveContext.Consumer>
        </Grommet>
      </BrowserRouter>
    </HeaderHeightProvider>
  );
}

export default App;
